@if (skeleton) {
  <tidy-card class="happiness-card sk-card">
    <div class="happiness-card__header">
      <ion-skeleton-text [animated]="true" class="sk-icon-tile" />
      <div class="happiness-card__title">
        <ion-skeleton-text [animated]="true" class="sk-card-name" />
      </div>
    </div>

    <div class="happiness-card__flags">
      <div class="happiness-card__flag-row">
        <div class="happiness-card__flag-label">
          <ion-skeleton-text [animated]="true" class="sk-flag-label" />
        </div>
        <ion-skeleton-text [animated]="true" class="sk-flag-toggle" />
      </div>
      <div class="happiness-card__flag-row">
        <div class="happiness-card__flag-label">
          <ion-skeleton-text [animated]="true" class="sk-flag-label" />
        </div>
        <ion-skeleton-text [animated]="true" class="sk-flag-toggle" />
      </div>
    </div>
  </tidy-card>
} @else {
  <tidy-card class="happiness-card" (click)="onCardClick()">
    <div class="happiness-card__header">
      <tidy-card-icon-block [iconSrc]="iconSrc" [variant]="'happiness'" />
      <div class="happiness-card__title">
        <tidy-text [header]="item.name" [translate]="false" />
      </div>
    </div>

    <div class="happiness-card__flags" (click)="stopPropagation($event)">
      <div class="happiness-card__flag-row">
        <div class="happiness-card__flag-label">
          <tidy-text [body]="'Allow Upsell'" />
        </div>
        <tidy-toggle
          [toggled]="item.can_upsell"
          (toggleChanged)="onUpsellChange($event)" />
      </div>
      <div class="happiness-card__flag-row">
        <div class="happiness-card__flag-label">
          <tidy-text [body]="'Allow Comp'" />
        </div>
        <tidy-toggle
          [toggled]="item.can_comp"
          (toggleChanged)="onCompChange($event)" />
      </div>
    </div>
  </tidy-card>
}
